const getters = {
  token: state => state.user.token,
  name: state => state.user.userInfo.name,
  userInfo: state => state.user.userInfo || {},
  appConfig: state => state.app.appConfig,
  thesisProcess: state => state.user.thesisProcess
}
export default getters
